import SetWaitingPeriod from 'adminDashboard/benefitDetails/common/productClassWizardModal/components/setWaitingPeriod'

import { SetIchraWaitingPeriodRequest, setIchraWaitingPeriod } from 'core'

import { useCommandRequestV2 } from 'common/hooks'

import { BaseComponentProps } from '../../../../../common/productClassWizardModal/Common'

export type SetWaitingPeriodFormProps = {
  productClassId: string
  waitingPeriod?: number
}

const SetWaitingPeriodForm = (props: BaseComponentProps<SetWaitingPeriodFormProps>) => {
  const { sendCommand: SetIchraWaitingPeriodRequest } = useCommandRequestV2((request: SetIchraWaitingPeriodRequest) =>
    setIchraWaitingPeriod(request),
  )

  const commandHandler = async (values: { waitingPeriod: number }) => {
    const result = await SetIchraWaitingPeriodRequest({
      waitingPeriod: values.waitingPeriod,
      productClassId: props.state.productClassId,
    })
    return result
  }

  return <SetWaitingPeriod commandHandler={commandHandler} {...props} />
}

export default SetWaitingPeriodForm
